const Delete = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 48 48"
		fill="none"
		{...props}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={4}
			d="m29.48 18-.692 18m-9.576 0-.692-18m19.936-6.42c.684.104 1.364.214 2.044.332m-2.044-.332L36.32 39.346a4.5 4.5 0 0 1-4.488 4.154H16.168a4.5 4.5 0 0 1-4.488-4.154L9.544 11.58m28.912 0a96.206 96.206 0 0 0-6.956-.794m-21.956.794c-.684.102-1.364.212-2.044.33m2.044-.33a96.206 96.206 0 0 1 6.956-.794m15 0V8.954c0-2.36-1.82-4.328-4.18-4.402-2.213-.07-4.427-.07-6.64 0-2.36.074-4.18 2.044-4.18 4.402v1.832m15 0a97.32 97.32 0 0 0-15 0"
		/>
	</svg>
);
export default Delete;
